import React, { useEffect, useRef } from "react";
import "./confirmModal.css";

const ConfirmModal = ({ message, onConfirm, onCancel }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const previousActiveElement = document.activeElement;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onCancel();
      }
    };

    if (modalRef.current) {
      modalRef.current.focus(); // move focus into the modal
    }

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      if (previousActiveElement) previousActiveElement.focus(); // return focus to previous element
    };
  }, [onCancel]);

  return (
    <div className="modal-overlay">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        tabIndex={-1}
        ref={modalRef}
        className="modal"
      >
        <h2 id="modal-title">Please Confirm</h2>
        <p>{message}</p>
        <div className="modal-buttons">
          <button className="confirm-btn" onClick={onConfirm}>Yes</button>
          <button className="cancel-btn" onClick={onCancel}>No</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
